// extracted by mini-css-extract-plugin
export default {"bgdetails":"contactpage_bgdetails__LuGHw"};